import { useState, useEffect } from "react";
import { Payment } from "@mercadopago/sdk-react";
import { useParams } from "react-router-dom";
import StatusUpdate from "./StatusUpdate";
import axios from "axios";
import LoadingPage from "./LoadingPage";
import Cookies from "js-cookie";
import { MessageError } from "./MessageError";

const PayamentMP = () => {
  const params = useParams();
  let plan_name = params["plan_name"];

  const [sessionPage, setSessionPage] = useState("loading");
  const [initializationPayment, setInitializationPayment] = useState(null);
  const [iid, setIid] = useState(null);
  const [messageError, setMessageError] = useState("");
  function moldeInitialization(amount, preferenceID) {
    setInitializationPayment({
      amount: amount,
      preferenceId: preferenceID,
    });
  }

  const customization = {
    paymentMethods: {
      ticket: "all",
      bankTransfer: "all",
      creditCard: "all",
      prepaidCard: "all",
      debitCard: "all",
      mercadoPago: "all",
    },
  };

  const onSubmit = async ({ selectedPaymentMethod, formData }) => {
    const b4726486 = Cookies.get("b4726486");
    let completData = {
      
      metadata: {
        token: b4726486,
        plan_name: plan_name,
      },
      ...formData,
    };


    
    try {
      const res = await axios.post("https://arbitragem.bet:3131/payment/process/", {
        ...completData,
      });
      if (
        res.data.status === "rejected" &&
        res.data.status === "cancelled" &&
        res.data.status === "refunded" &&
        res.data.status === "charged_back"
      ) {
        setMessageError("Erro ao processar o pagamento.");
        setSessionPage("error");
      } else {
        setIid(res.data.id);
        setSessionPage("pay");
      }
    } catch (err) {

      

      let dataResponse = err.response.data;



      
      if(dataResponse["message"] !== undefined){
        setMessageError(dataResponse["message"]);
        setSessionPage("error");
      }
      else{
      alert("Erro ao processar o pagamento.");
      }
    }
  };

  const onError = async (error) => {
    console.log(error);
  };
  const onReady = async () => { return null };

  function getPreference() {
    const b4726486 = Cookies.get("b4726486");
    const dataToSend = { token: b4726486, plan_name: plan_name };

    fetch("https://arbitragem.bet:3131/payment/create_preference/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(dataToSend),
    })
      .then((data) => data.json())
      .then((data) => {
        if (data["message"] !== undefined) {
          setMessageError(data["message"]);
          setSessionPage("error");
        } else {
          
          moldeInitialization(data["amount"], data["preferenceId"]);

          setSessionPage("select_payment");
        }
      })
      .catch(async (error) => {
        if (error instanceof Response) {
          const errorData = await error.json();

          if ("message" in errorData) {
            setMessageError(errorData["message"]);
            setSessionPage("error");
          }
        }
      });
  }

  useEffect(() => {
    getPreference();
  }, []);

  return (
    <>
      {sessionPage === "loading" ? (
        <LoadingPage />
      ) : sessionPage === "select_payment" ? (
        <Payment
          initialization={initializationPayment}
          customization={customization}
          onSubmit={onSubmit}
          onReady={onReady}
          onError={onError}
        />
      ) : sessionPage === "pay" ? (
        <StatusUpdate preferenceID={iid} />
      ) : (
        <MessageError message={messageError} />
      )}
    </>
  );
};

export default PayamentMP;
